import { Controller } from "@hotwired/stimulus"

// "Everyone is here" — sets every row of the roll to one status in a tap.
export default class extends Controller {
  markAll(event) {
    event.preventDefault()
    const status = event.currentTarget.dataset.status
    this.element.querySelectorAll(`input[type=radio][value="${status}"]`).forEach((radio) => { radio.checked = true })
  }
}
